// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_buS","cls2":"ChatInterface-cls2_k6Z ChatInterface-cls1_buS"};